<ym-avatar [size]="size" [name]="user?.first_name|| user?.last_name ||user?.email||''"
    [src]="user?.avatar||''"></ym-avatar>